import React from "react";

export default function BookFileField({ label, name, accept, file, onChange, existing, className = "" }) {
  return (
    <label className={`file-upload-card ${file || existing ? "has-file" : ""} ${className}`.trim()}>
      <span className="file-upload-card-top">
        <span className="file-upload-label">{label}</span>
        {existing && !file ? <span className="file-upload-existing">On file</span> : null}
      </span>
      <input type="file" name={name} accept={accept} onChange={onChange} />
      <span className="file-upload-name">
        {file?.name || (existing ? "Keep current file, or choose a new one" : "No file chosen")}
      </span>
    </label>
  );
}
